export default __webpack_public_path__ + "static/media/dreamfest (8).add6c530.jpg";